import { useNavigate, useParams } from 'react-router-dom';
import { HeartPulse } from 'lucide-react';
import { useHealth } from '../../contexts/HealthContext';
import { usePets } from '../../contexts/PetsContext';
import Button from '../../components/ui/Button';
import Card from '../../components/ui/Card';
import { ROUTES } from '../../config/constants';
import HealthRecordForm from './components/HealthRecordForm';

const HealthRecordEditPage = () => {
  const { petId, recordId } = useParams();
  const navigate = useNavigate();
  const { getRecordById, status: healthStatus } = useHealth();
  const { pets, status: petsStatus } = usePets();

  if (healthStatus === 'loading' || petsStatus === 'loading') {
    return (
      <div className="flex flex-col gap-2">
        <div className="h-12 animate-pulse rounded-2xl bg-slate-100" />
        <div className="h-32 animate-pulse rounded-2xl bg-slate-100" />
      </div>
    );
  }

  const record = getRecordById(recordId);
  const pet = pets.find((p) => p.id === petId);

  if (!record || !pet) {
    return (
      <div className="flex flex-col gap-4">
        <h1 className="text-2xl font-bold text-slate-900">Observación no encontrada</h1>
        <Card>
          <p className="text-sm text-slate-600">
            Esta observación no existe o fue eliminada.
          </p>
          <div className="mt-3">
            <Button
              variant="secondary"
              fullWidth
              onClick={() => navigate(petId ? ROUTES.PET_HEALTH.replace(':petId', petId) : ROUTES.HEALTH)}
            >
              Volver
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-start gap-2">
        <HeartPulse className="h-6 w-6 text-rose-700" aria-hidden="true" />
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Editar observación</h1>
          <p className="text-sm text-slate-500">De {pet.name}.</p>
        </div>
      </div>
      <HealthRecordForm petId={petId} record={record} />
    </div>
  );
};

export default HealthRecordEditPage;
